<template>
  <q-layout view="hHh lpR fFf">
    <q-header class="bg-white text-primary">
      <q-toolbar v-if="showBackToolbar" class="q-py-md">
        <q-btn
          flat
          dense
          no-caps
          icon="arrow_back"
          class="text-primary"
          :label="$t('login.goBack')"
          @click="$router.push({ path: '/' })"
        />
        <q-space />
        <img src="~assets/sowell-logo.svg" alt="SoWell" class="sw-brand-logo" />
      </q-toolbar>
      <q-toolbar v-else>
        <q-toolbar-title class="text-center q-pt-xl">
          <img
            src="~assets/sowell-logo.svg"
            alt="SoWell"
            class="sw-brand-logo sw-brand-logo--login"
          />
        </q-toolbar-title>
      </q-toolbar>
    </q-header>
    <q-page-container>
      <router-view />
    </q-page-container>
    <q-footer :class="{ 'safe-area-footer': needInset.all }" class="bg-white">
      <div class="text-grey-8 float-right q-mr-sm" :class="{ 'q-mb-md': $q.platform.is.android, 'safe-area-footer': $q.platform.is.ios }">{{ appVersion }}</div>
    </q-footer>
  </q-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      appVersion: ''
    }
  },
  computed: {
    showBackToolbar() {
      return ['ResetPassword', 'FirstLogin', 'SetPassword'].includes(
        this.$route.name
      )
    },
    ...mapGetters({
      qrCode: 'reporter/qrCode',
      needInset: 'common/needInset'
    })
  },
  mounted() {
    if (this.qrCode) {
      this.$store.dispatch('reporter/setQrCode', null)
    }
    this.appVersion = process.env.APP_VERSION
  }
}
</script>

<style lang="scss" scoped>
.sw-brand-logo {
  height: 32px;
  width: auto;
}

.sw-brand-logo--login {
  height: 47px;
}
</style>
